import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Bindet die Browser-Fullscreen-API an ein DOM-Ref.
 * Reagiert auf externe Änderungen (z.B. Escape-Taste), sodass UI-Buttons
 * den korrekten State zeigen.
 */
export function useFullscreen<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const onChange = () => {
      setIsFullscreen(document.fullscreenElement === ref.current);
    };
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const toggle = useCallback(() => {
    if (document.fullscreenElement === ref.current) {
      void document.exitFullscreen().catch(() => undefined);
      return;
    }
    if (ref.current?.requestFullscreen) {
      void ref.current.requestFullscreen().catch(() => undefined);
    }
  }, []);

  return { ref, isFullscreen, toggle };
}
